/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { traitsContract } from "config";
import { useContractWrite, useWaitForTransaction } from "wagmi";
import useSnackbarRpcError from "hooks/useSnackbarRpcError";
import useCaptureRpcException from "hooks/useCaptureRpcException";

const useApproveTraits = (
  spender?: string,
  onSuccess?: () => void
): [() => void, boolean | undefined] => {
  const [{ data, loading: isLoading, error: writeError }, approve] =
    useContractWrite(
      {
        addressOrName: traitsContract.address,
        contractInterface: traitsContract.interface,
      },
      "setApprovalForAll",
      {
        args: [spender, true],
      }
    );

  const [{ data: waitData, loading: isWaiting, error: waitError }] =
    useWaitForTransaction({
      wait: data?.wait,
    });

  useSnackbarRpcError(writeError);
  useSnackbarRpcError(waitError);

  useCaptureRpcException(waitError);
  useCaptureRpcException(writeError);

  useEffect(() => {
    if (!isWaiting && waitData) {
      onSuccess?.();
    }
  }, [isWaiting, waitData]);

  return [approve, isLoading || isWaiting];
};

export default useApproveTraits;
